import React, { useEffect, useRef, useState } from 'react';
import './ActivationStatus.scss';
import unsuccessfulIcon from '../../Assets/images/Activation/Steps/unsuccessfulIcon.svg';
import phoneIcon from '../../Assets/images/Activation/Steps/phone.svg';
import { activationPage } from '../../global/texts/postActivation/activation';
import TextField from '../Textfield/TextField';
import Button from '../Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import SimpleHeader from '../../components/Header/simpleHeader';
import successIcon from '../../Assets/images/Activation/success.svg';
import inProgressIcon from '../../Assets/images/Activation/inProgress.svg';
import { activation, activationStatus } from '../../store/Activation/actions';
import BannerImg from '../../Assets/images/Activation/activationBanner.webp';
import BannerIpadImg from '../../Assets/images/Activation/activationBannerIPad.webp';
import Footer from '../Footer/Footer';
// import { pushTrackingEventsToGAAndFBNew } from '../../global/commonFunctions/GaAndFb';
import TagManager from 'react-gtm-module';

type initialProps = {
    statusPassword?: any;
    activateHandler?: any;
    history?: any;
};

const ActivationStatus = (props: initialProps) => {
    // const { activateHandler } = props;
    const [user, setUser] = useState<any>('');
    const [accountNumber, setAccountNumber] = useState('');
    const [portInProgress, setPortInProgress] = useState<boolean>(false);
    const [accountErr, setAccountErr] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [zipCodeErr, setZipCodeErr] = useState('');
    const [pinNumber, setPinNumber] = useState('');
    const [pinNumberErr, setPinNumberErr] = useState('');
    const [portFailedCust, setPortFailedCust] = useState<any>(null);
    const [isAcc, setIsAcc] = useState(false);
    const [isPin, setIsPin] = useState(false);
    const [isZip, setIsZip] = useState(false);
    const [loader, setLoader] = useState<boolean>(false);
    const [portSuccess, setPortSuccess] = useState<boolean>(false);
    const [isGenericErr, setIsGenericErr] = useState(false);
    const [curStatusData, setCurStatusData] = useState<any>(null);
    const status = useSelector((state: any) => state.activation.activationStatus);
    const activationState = useSelector((state:any) => state.activation.activation);
    const dispatch = useDispatch();

    useEffect(() => {
        let data = props.history?.location;
        if(data.state?.portFailedData) {
            setPortFailedCust(data.state?.portFailedData);
            if (data.state?.portFailedData?.portFailureCode === 1009) {
                setIsAcc(true);
            }
            if (data.state?.portFailedData?.portFailureCode === 1010) {
                setIsPin(true);
            }
            if (data.state?.portFailedData?.portFailureCode === 1011) {
                setIsZip(true);
            }
        }
        if(data?.state?.portInProgress) {
            setPortInProgress(data.state.portInProgress);
        }
        if(data?.state?.genericErr) {
            setIsGenericErr(data.state.genericErr)
        }
        if(data?.state?.user) {
            setUser(data.state.user)
            dispatch(
                activationStatus({
                    customerId: data?.state?.user.id,
                }),
            );
        }
    }, []);

    const initialRender1 = useRef(true);

    useEffect(() => {
        if (initialRender1.current) {
            initialRender1.current = false;
        } else {
            if (status && status.status === 'SUCCESS' && status.data) {
                setCurStatusData(status.data);
                const data = status?.data;
                if(loader) {
                    setLoader(false);
                }
                if (data && data.status === 10) {
                    if(!props.history?.location?.state?.portFailedData) {
                        setPortFailedCust(status.data)
                    }
                    if (data.portFailureCode === 1009) {
                        setIsAcc(true);
                        setIsPin(false);
                        setIsZip(false);
                        setPortInProgress(false);
                    }
                    if (data.portFailureCode === 1010) {
                        setIsAcc(false);
                        setIsPin(true);
                        setIsZip(false);
                        setPortInProgress(false);
                    }
                    if (data.portFailureCode === 1011) {
                        setIsAcc(false);
                        setIsPin(false);
                        setIsZip(true);
                        setPortInProgress(false);
                    }
                    if (
                        data.portFailureCode == undefined ||
                        data.portFailureCode == null ||
                        (data.portFailureCode != 1017 &&
                            data.portFailureCode != 1011 &&
                            data.portFailureCode != 1010 &&
                            data.portFailureCode != 1009)
                    ) {
                        setIsGenericErr(true);
                        setPortInProgress(false);
                    }
                } else if (data?.status === 2) {
                    setPortSuccess(true);
                    setIsAcc(false);
                    setIsPin(false);
                    setIsZip(false)
                } else if (data?.status === 9) {
                    setPortInProgress(true);
                    setIsAcc(false);
                    setIsPin(false);
                    setIsZip(false)
                    setTimeout(()=> {
                        dispatch(
                            activationStatus({
                                customerId: user && user.id,
                            }),
                        );
                    },5000)
                }
            }
        }
    }, [status]);

    const initialRender2 = useRef(true);
    useEffect(()=> {
        if(initialRender2.current){
            initialRender2.current = false;
        } else {
            if(activationState && activationState.status === 'SUCCESS') {
                dispatch(
                    activationStatus({
                        customerId: user && user.id,
                    }),
                );
            } else {
                setLoader(false);
            }
        }
    },[activationState])

    const onChangeHandler = async (e: any, name: string) => {
        if (name === 'accountNumber') {
            setAccountNumber(e.target.value);
            setAccountErr('');
        } else if (name === 'zip') {
            setZipCode(e.target.value);
            setZipCodeErr('');
        } else if (name === 'pin') {
            setPinNumber(e.target.value);
            setPinNumberErr('');
        }
    };
    const accountUpdate = () => {
        if (accountNumber !== '' && accountErr === '' && accountNumber.length <= 20) {
            if(portFailedCust) {
                let payload: any = {
                    customerId: portFailedCust.customerId,
                    reachPlanId: portFailedCust?.reachPlanId,
                    iccId: portFailedCust?.iccId ? portFailedCust.iccId : user?.simId ? user.simId : '',
                    imei: portFailedCust?.imei,
                    make: portFailedCust?.make,
                    model: portFailedCust?.model,
                    isPort: true,
                    numberToPort: portFailedCust?.numberToPort.replace(/(\D)/g, ''),
                    oldCarrier: portFailedCust?.oldCarrier,
                    portUpdate: true,
                    oldCarrierAccountNumber: accountNumber,
                    oldZip: portFailedCust?.oldZip,
                    password: portFailedCust?.password,
                };
                activateHandler(payload);
            }
            else if (user) {
                let payload: any = {
                    customerId: user && user.id,
                    reachPlanId: user && user.reachPlanId,
                    iccId: user?.simId ? user.simId : '',
                    imei: user && user.imei,
                    make: user && user.make,
                    model: user && user.model,
                    isPort: true,
                    numberToPort: user && user.mnpInfo && user.mnpInfo.oldNumber.replace(/(\D)/g, ''),
                    oldCarrier: user && user.mnpInfo && user.mnpInfo.operator,
                    portUpdate: true,
                    oldCarrierAccountNumber: accountNumber,
                    oldZip: user && user.mnpInfo && user.mnpInfo.oldZip,
                    password: curStatusData.password,
                };
                activateHandler(payload);
            }
        } else {
            if (accountNumber === '') {
                setAccountErr('This field is required.');
            } else if (accountNumber !== '') {
                setAccountErr('Invalid Format.');
            } else if (accountNumber.length > 20) {
                setAccountErr('Account number should be less than 20 characters.');
            }
        }
    };
    const pinUpdate = () => {
        if (pinNumber !== '' && pinNumberErr === '') {
            if(portFailedCust) {
                let payload: any = {
                    customerId: portFailedCust.customerId,
                    reachPlanId: portFailedCust?.reachPlanId,
                    iccId: portFailedCust?.iccId ? portFailedCust.iccId : user?.simId ? user.simId : '',
                    imei: portFailedCust?.imei,
                    make: portFailedCust?.make,
                    model: portFailedCust?.model,
                    isPort: true,
                    numberToPort: portFailedCust?.numberToPort.replace(/(\D)/g, ''),
                    oldCarrier: portFailedCust?.oldCarrier,
                    portUpdate: true,
                    oldCarrierAccountNumber: portFailedCust?.oldCarrierAccountNumber,
                    oldZip: portFailedCust?.oldZip,
                    password: pinNumber,
                };
                activateHandler(payload);
            }
            else if (user) {
                let payload: any = {
                    customerId: user && user.id,
                    reachPlanId: user && user.reachPlanId,
                    iccId: user?.simId ? user.simId : '',
                    imei: user && user.imei,
                    make: user && user.make,
                    model: user && user.model,
                    isPort: true,
                    numberToPort: user && user.mnpInfo && user.mnpInfo.oldNumber.replace(/(\D)/g, ''),
                    oldCarrier: user && user.mnpInfo && user.mnpInfo.operator,
                    portUpdate: true,
                    oldCarrierAccountNumber: user && user.mnpInfo && user.mnpInfo.acctNum,
                    password: pinNumber,
                    oldZip: user && user.mnpInfo && user.mnpInfo.oldZip,
                };
                activateHandler(payload);
            }
        } else {
            setPinNumberErr('This field is required.');
        }
    };
    const zipUpdate = () => {
        if (zipCode !== '' && /^\d{5,10}$/.test(zipCode) && zipCodeErr === '') {
            if(portFailedCust) {
                let payload: any = {
                    customerId: portFailedCust.customerId,
                    reachPlanId: portFailedCust?.reachPlanId,
                    iccId: portFailedCust?.iccId ? portFailedCust.iccId : user?.simId ? user.simId : '',
                    imei: portFailedCust?.imei,
                    make: portFailedCust?.make,
                    model: portFailedCust?.model,
                    isPort: true,
                    numberToPort: portFailedCust?.numberToPort.replace(/(\D)/g, ''),
                    oldCarrier: portFailedCust?.oldCarrier,
                    portUpdate: true,
                    oldCarrierAccountNumber: portFailedCust?.oldCarrierAccountNumber,
                    oldZip: zipCode,
                    password: portFailedCust?.password,
                };
                activateHandler(payload);
            }
            else if (user) {
                let payload: any = {
                    customerId: user && user.id,
                    reachPlanId: user && user.reachPlanId,
                    iccId: user?.simId ? user.simId : '',
                    imei: user && user.imei,
                    make: user && user.make,
                    model: user && user.model,
                    isPort: true,
                    numberToPort: user && user.mnpInfo && user.mnpInfo.oldNumber.replace(/(\D)/g, ''),
                    oldCarrier: user && user.mnpInfo && user.mnpInfo.operator,
                    portUpdate: true,
                    oldCarrierAccountNumber: user && user.mnpInfo && user.mnpInfo.acctNum,
                    oldZip: zipCode,
                    password: curStatusData.password,
                };
                activateHandler(payload);
            }
        } else {
            if (zipCode === '') {
                setZipCodeErr('This field is required.');
            } else if (!/^\d{5,10}$/.test(zipCode)) {
                setZipCodeErr('Enter valid zipcode.');
            }
        }
    };
    const updateHandler = () => {
        if (isAcc) accountUpdate();
        else if (isPin) pinUpdate();
        else if (isZip) zipUpdate();
    };
    const activateHandler = (payload:any) => {
        setLoader(true);
        dispatch(activation(payload))
    };
    // const GAAndFBEventsHandler = (buttonVal: string) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "home",
    //       buttonValue: buttonVal, 
          
    //     });
    //   };
    let customerDetail: any = localStorage.getItem('customerDetail');
    customerDetail = JSON.parse(customerDetail);
    return (
        <>
            <SimpleHeader history={props.history} user={customerDetail} isHelp={true} />
            <div className="bannerImg">
                    <img src={BannerImg} alt="img" className="WebImg" />
                    <img src={BannerIpadImg} alt="img" className="IpadImg" />
                    <div className="contentCarousel">
                        <div className="Goodbye-mobile-store">
                            Activation
                        </div>
                    </div>
                </div>
            <div className="messageContainer">
                {portInProgress ? (
                    <>
                        <img src={inProgressIcon} alt="inProgressIcon" className="icon" />
                        <div className="title">{activationPage.portingMessage.inProgress}</div>
                        <div className="message">
                            Porting for {user?.firstName && `${user?.firstName?.toUpperCase()}'s`} line has begun. Please click the green ‘Continue to Home’ button to monitor the porting progress. We will let you know once the activation process is complete.
                        </div>
                        <div className="backToHome">
                            <Button
                                primary={true}
                                onClick={() => props.history.push('/post-activation-home')}
                            >
                                Continue To Home
                            </Button>
                        </div>
                    </>
                ) : portSuccess ? (
                    <>
                        <img src={successIcon} alt="successIcon" className="icon" />
                        <div className="title">{activationPage.portingMessage.success}</div>
                        <div className="message">
                            Congratulations! {user?.firstName?.toUpperCase()} line has been successfully activated. You can now
                            enjoy all the features and benefits of our eSIM service.
                        </div>
                        <Button primary={true} onClick={() => {
                                props.history.push('/steps')
                                // GAAndFBEventsHandler("ContinueSetup")
                                TagManager.dataLayer({
                                    dataLayer: {
                                      event: "ContinueSetup",
                                    },
                                  });
                            }}>
                            CONTINUE TO SETUP
                        </Button>
                    </>
                ) : (
                    <>
                        <img src={unsuccessfulIcon} alt="unsuccessfulIcon" className="icon" />
                        <div className="title">{activationPage.portingMessage.title}</div>
                        <div className="message">
                            {isAcc && activationPage.portingMessage.numberPortingError}
                            {isZip && activationPage.portingMessage.zipPortingError}
                            {isPin && activationPage.portingMessage.pinPortingError}
                            {isGenericErr && activationPage.portingMessage.genericPortingError}
                            {portInProgress && activationPage.portingMessage.inProgress}
                        </div>
                        {isGenericErr ? (
                            <>
                                <div className="customerSupport">
                                    <img src={phoneIcon} alt="phoneIcon" className="phoneIcon" />
                                    <span className="supportNum">{activationPage.portingMessage.customerCare}</span>
                                </div>
                                <div className="homeLink" onClick={() => props.history.push('/post-activation-home')}>
                                    Home
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="textFieldConatiner">
                                    <div className="inputFieldLabel">
                                        {isAcc && activationPage.portingMessage.accNumberTitle}
                                        {isZip && activationPage.portingMessage.zipCodeTitle}
                                        {isPin && activationPage.portingMessage.pinTitle}
                                    </div>
                                    <div>
                                        {isAcc && (
                                            <TextField
                                                value={accountNumber}
                                                type={'text'}
                                                onChange={(e: any) => {
                                                    if (
                                                        /^[a-zA-Z0-9]+$/.test(e.target.value) ||
                                                        e.target.value === '' ||
                                                        e.target.value < 20
                                                    ) {
                                                        onChangeHandler(e, 'accountNumber');
                                                    }
                                                }}
                                                error={accountErr !== ''}
                                                helperText={accountErr}
                                            />
                                        )}
                                        {isZip && (
                                            <TextField
                                                value={zipCode}
                                                type={'text'}
                                                onChange={(e: any) => {
                                                    if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                                        onChangeHandler(e, 'zip');
                                                    }
                                                }}
                                                error={zipCodeErr !== ''}
                                                helperText={zipCodeErr}
                                                maxlength={10}
                                            />
                                        )}
                                        {isPin && (
                                            <TextField
                                                value={pinNumber}
                                                type={'text'}
                                                onChange={(e: any) => onChangeHandler(e, 'pin')}
                                                error={pinNumberErr !== ''}
                                                helperText={pinNumberErr}
                                            />
                                        )}
                                    </div>
                                </div>
                                <Button primary={true} onClick={updateHandler}>
                                {loader ? (
                                    <div
                                        className="spinner-border"
                                        role="status"
                                        style={{
                                            alignSelf: 'center',
                                        }}
                                    />
                                    ) : (
                                        'CONTINUE'
                                    )}
                                </Button>
                            </>
                        )}
                    </>
                )}
            </div>
            <Footer />
        </>
    );
};

export default ActivationStatus;
